import { forwardRef, type HTMLAttributes } from 'react'
import { cn } from '@/lib/cn'
import styles from './Logo.module.scss'

export type LogoVariant = 'mark' | 'full'
export type LogoSize = 'sm' | 'md' | 'lg'

export interface LogoProps extends HTMLAttributes<HTMLSpanElement> {
  variant?: LogoVariant
  size?: LogoSize
}

const MARK_DIMENSIONS: Record<LogoSize, number> = {
  sm: 22,
  md: 28,
  lg: 40,
}

export const Logo = forwardRef<HTMLSpanElement, LogoProps>(function Logo(
  { variant = 'full', size = 'md', className, ...rest },
  ref,
) {
  const dim = MARK_DIMENSIONS[size]

  return (
    <span
      ref={ref}
      className={cn(styles.logo, styles[`size-${size}`], className)}
      aria-label="Prism"
      {...rest}
    >
      <img src="/brand/prism-mark.svg" width={dim} height={dim} alt="" className={styles.mark} />
      {variant === 'full' ? <span className={styles.wordmark}>Prism</span> : null}
    </span>
  )
})
